import { Pipe, PipeTransform } from '@angular/core';
import { Regex } from '../../common';

// Adds dash spacing to a string
// eg:
// '11112222' -> '11-11-22-22'
// '1111222233334444-5' -> '11-11-22-22-33-33-44-44-5'
// ['12-34-56-78', 'AA-AA-BB-BB'] -> ['12-34-56-78', 'AA-AA-BB-BB']
@Pipe({
  name: 'serialSpacing',
})
export class SerialSpacingPipe implements PipeTransform {
  transform(value: string | string[]): string | string[] {
    if (!value) {
      return value;
    }

    if (Array.isArray(value)) {
      return value.map((entry) => {
        return this.spaceText(entry);
      });
    } else {
      return this.spaceText(value);
    }
  }

  spaceText(text: string): string {
    // Only first 16 letters should be spaced, rest should be left untouched
    const chars16 = text.slice(0, 16);
    const rest = text.slice(16, text.length);

    const regex = Regex.twoCharSequence;
    const elements = chars16.match(regex);

    return `${elements.join('-')}${rest}`.toUpperCase();
  }
}
